export default {
  container: {
    padding: '24px',
    paddingTop: '100px',
    maxWidth: '1200px',
    margin: '0 auto'
  }
}
